/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/DesignSystem/EditAutomation/SaveAction/Error"
  
}) {
  return null
}